import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router preserves scroll position across route changes by default,
// which reads as broken navigation on a multi-page site.
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
